export default {
  dbi_benchmark_pc_console_benchmark: '端游&主机游戏Gaas分析',
  dbi_benchmark_about_the_data: '关于数据',
  dbi_benchmark_figure: '图表',
  dbi_benchmark_stats: '统计',
  dbi_benchmark_shooter: '射击',
  dbi_benchmark_soc: '开放世界生存',
  dbi_benchmark_rpg: '角色扮演',
  dbi_benchmark_mmp: '大型多人在线',
  dbi_benchmark_casual: '休闲',
  dbi_benchmark_customized: '定制',
  dbi_benchmark_time_basis: '时间基准',
  dbi_benchmark_align_across: '对齐PC版和主机版的时间轴',
  dbi_benchmark_summary: '总结',
  dbi_benchmark_us_digital_revenue_units: '美国电子版收入和销量趋势',
  dbi_benchmark_gass_revenue: 'GaaS 收入占美国电子版收入的百分比',
  dbi_benchmark_players_by_Region: '按地区分布的玩家',
  dbi_benchmark_top_us_digital: '美国电子版收入排名前十的游戏',
  dbi_benchmark_gaas_capability: 'GaaS 能力： ARPMAU 和留存率',
  dbi_benchmark_distribution: '分布',
  dbi_benchmark_retention_rank_curve: '留存率等级曲线',
  dbi_benchmark_us_digital: '美国电子版',
  dbi_benchmark_price_steam_data: '价格和Steam数据',
  dbi_benchmark_player_engagement: '活跃度',
  dbi_benchmark_social_channels: '社交平台',
  dbi_benchmark_basic_info: '基本信息',
  dbi_benchmark_platform: '平台',
  dbi_benchmark_start_date: '开始日期',
  dbi_benchmark_monetization: '商业化',
  dbi_benchmark_metric_type: '指标类型',
  dbi_benchmark_pc_console: 'PC游戏+主机游戏',
  dbi_benchmark_all_sum: '所有总和',
  dbi_benchmark_premium: '游戏本体付费',
  dbi_benchmark_mtx_subscription: '微交易和订阅',
  dbi_benchmark_dlc_pass: '付费扩展包和通行证',
  dbi_benchmark_definition_selection: '不同时间基准选择的定义',
  dbi_benchmark_pc_version: 'PC版',
  dbi_benchmark_console_version: '主机版',
  dbi_benchmark_earliest_data_date: '最早数据日期',
  dbi_benchmark_release_date: '发布日期',
  dbi_benchmark_start_release_date: '从发布日期开始',
  dbi_benchmark_start_earliest_date: '从最早数据日期开始',
  dbi_benchmark_customize_set: '定制游戏列表',
  dbi_benchmark_put_all_games: '显示所有游戏',
  dbi_benchmark_introduce:
    '这些指标是根据 MScience、VG-Insights 等来源的数据总结出来的。如需了解更多信息，请随时联系 @zhaofengliu。',
  dbi_benchmark_methodology: '方法',
  dbi_benchmark_data_source: '数据源',
  dbi_benchmark_contact_us: '联系我们',
  dbi_benchmark_revenue_p: '收入%',
  dbi_benchmark_units_p: '销量%',
  dbi_benchmark_my_filter: '我的过滤',
  dbi_benchmark_setting: '设置',
  dbi_benchmark_total: '总量',
  dbi_benchmark_earliest_release: '最早日期 ~ 发布日期',
  dbi_benchmark_digital_units_info: '每款游戏电子售价加权平均值',
  dbi_benchmark_digital_revenue_info: '按每款游戏电子版收入加权的平均值',
  dbi_benchmark_feedback: '如果您对数据性能有任何反馈或疑问，请随时联系我们。',
  dbi_benchmark_msicence_info: '提供美国PC端和主机端游戏的电子版收入和销量',
  dbi_benchmark_vg_insights_info: '提供 Steam 游戏收入、数量、价格和玩家国家分布情况',
  dbi_benchmark_newzoo_info: '提供PC端和主机端的游玩时长和 MAU。',
  dbi_benchmark_steam_info: '提供 PCU、ACU 以及评论和关注人数信息。',
  dbi_benchmark_unit_info: 'PC端比例 = PC端/（PC端+主机端）；主机端比例 = 主机端/（PC端+主机端）',
  dbi_benchmark_pc_revenue_pro: 'PC游戏收入比例',
  dbi_benchmark_console_revenue_pro: '主机游戏收入比例',
  dbi_benchmark_console_units_pro: 'PC游戏销量比例',
  dbi_benchmark_pc_units_pro: '主机游戏销量比例',
  dbi_benchmark_pc_version_u: 'PC版',
  dbi_benchmark_add: '添加',
  dbi_benchmark_year: '第{num}年',
  dbi_benchmark_release: '发布日期',
  dbi_benchmark_players_proportion: '用户分布',
  dbi_benchmark_poe_like: '流放之路类似游戏',

  dbi_benchmark_retention_d30: '留存(D30)',

  dbi_benchmark_follow_game: '关注所有游戏',
  dbi_benchmark_follow_game_hover: '关注该品类下所有已选游戏',
  dbi_benchmark_game_add_header: '{type}游戏被添加',
  dbi_benchmark_follow_game_tip:
    '{count}款新增游戏已被添加, {name}分组已存在，是否将以上游戏添加至该分组？',
  dbi_benchmark_follow_game_tip_mobile:
    '从游戏级别过滤器中选择了{count}款游戏，并将其添加到“{name}”组中。',
  dbi_benchmark_follow_game_tip_combine: '{count}款游戏被添加到“{name}”组',
  dbi_benchmark_follow_game_genre: '关注该品类的游戏',
  dbi_benchmark_create_duplicate: '创建分组',
  dbi_benchmark_followed: '已关注',
  dbi_benchmark_new: '新增',
  dbi_benchmark_add_followed: '添加至分组成功!',
  dbi_benchmark_go_to_mange: '管理',
  dbi_benchmark_group_exists: '{type}分组已存在',
  dbi_benchmark_group_exists_qus: '所选游戏已关注，是否创建该分组副本？',

  dbi_benchmark_gaas_capability_faq: '如果您对如何计算指标有疑问，请访问相关情报{link}。',
  dbi_benchmark_about_data_faq: '如果您想了解有关 Benchmark 指标计算的更多信息，请访问{link}。',

  dbi_benchmark_us_digital_unit_info: `数据来源：MScience。这里显示的是发布日期后五年内的平均价格趋势。详细的游戏数据可在底部的 "统计：美国电子版"中。如果游戏数据中存在数据缺失或异常值，数据科学家将通过算法模型对趋势进行校准。`,
  dbi_benchmark_us_digital_revenue_info: `数据来源：MScience。这里显示的是最早日期之后五年内的平均收入趋势。详细游戏数据请参见页面底部的 "统计：美国电子版"中。如果游戏数据中存在数据缺失或异常值，数据科学家将通过算法模型对趋势进行校准。`,
  dbi_benchmark_gass_revenue_info:
    '数据来源：MScience： 游戏收入中的 Gaas 部分包括来自游戏 付费扩展包、微交易、通行证和订阅的收入，换句话说，即除游戏本体付费外的收入之和。详细的游戏数据可在页面底部的 "统计：美国电子版"中获得。如果游戏数据中存在数据缺失或异常值，数据科学家将通过算法模型对趋势进行校准。',
  dbi_benchmark_players_info:
    '数据来源：VG-Insights。呈现的结果由每款游戏在各地区玩家分布的平均值得出，游戏销量为权重。请注意，由于 VG-Insights 的数据基于 Steam，因此本图表仅反映 PC端用户的分布情况。',
  dbi_benchmark_data_source_info: `之所以选择这些数据源，是因为它们已通过 IEGG 的内部真实数据进行了双重检查，以确保数据的可靠性。`,
  dbi_benchmark_top_digital_revenue_info: `数据来源：MScience： 本图表根据迄今为止每款游戏在美国的数字收入总额进行排序，包括付费版本、付费拓展包、微交易数据、通行证和订阅。详细游戏数据可参见页面底部的 "统计：美国电子版"。`,
  dbi_benchmark_gass_capability_info: `数据源： 来自 DataBrain 的数据科学家。估算 ARPMAU 和留存率是通过基于 MScience、VG-Insights、Steam 和一些真实数据的算法模型计算得出的。ARPMAU "表示每月活跃用户在一个月内的平均付费，"留存率 "表示每个用户进入游戏后的平均活跃月数。这两项指标根据所选类型游戏的表现分为 5 个等级（S/A/B/C/D），选择 "自定义 "时，这两项指标将基于端游主机数据Benchmark 中所有游戏的表现。如果您对数据性能或竞品游戏有任何反馈或疑问，请随时联系 @zhaofengliu。`,
  dbi_benchmark_calibration_info: `1. 校准： 某些汇总指标可能会受到数据源原始数据中数据缺失或异常值的影响。如果所选品类或自定义游戏列表中有这样的游戏，则将使用算法模型进行数据校准。与指标高度相关的特征将从当前类型的所有游戏数据中被提取出来。对于自定义游戏列表，将使用从所有游戏数据中提取的特征来填补原始数据中的缺失或异常值。校准后的数据只会影响图表部分，以确保呈现的总结和图表更可靠、更有洞察力，但不会影响表格中呈现的数据。校准适用于 "图表 - 美国数字收入和销量趋势 "和 "图表 - GaaS 收入占美国数字收入的百分比"。参考数据来源包括 MScience 和 VG-insights。`,
  dbi_benchmark_estimation_info:
    '2. 估算： 考虑到一些关键指标在公共数据来源中无法获得或不可靠，Databrain 的数据科学家通过算法模型对其进行了估算，以填补该领域的空白。在当前版本的 PC主机数据Benchmark 中，提供了 ARPMAU 和留存率。第三方来源的原始数据被映射到特征向量空间，通过数学建模和回归获得这些指标。这两个指标根据所选类型游戏的表现分为 5 个等级（S/A/B/C/D）；当选择 "自定义 "时，这两个指标基于 PC Console Benchmark 中所有游戏的表现。估算适用于 "图表- GaaS能力： ARPMAU 和留存率"。参考数据来源包括 MScience、VG-Insights、Steam 和一些真实数据。',
};
